import { ProductScreenshot } from 'components/ProductScreenshot';
import QueryJoinExample from "../../../../contents/docs/data-warehouse/snippets/query-join-example.mdx";
import * as React from 'react';
export default {
  ProductScreenshot,
  QueryJoinExample,
  React
};